import { render, staticRenderFns } from "./BusinessNotice.vue?vue&type=template&id=487b7cce&scoped=true"
import script from "./BusinessNotice.vue?vue&type=script&lang=js"
export * from "./BusinessNotice.vue?vue&type=script&lang=js"
import style0 from "./BusinessNotice.vue?vue&type=style&index=0&id=487b7cce&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487b7cce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('487b7cce')) {
      api.createRecord('487b7cce', component.options)
    } else {
      api.reload('487b7cce', component.options)
    }
    module.hot.accept("./BusinessNotice.vue?vue&type=template&id=487b7cce&scoped=true", function () {
      api.rerender('487b7cce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shop/components/form/BusinessNotice.vue"
export default component.exports